import React from 'react';
import { useLocation } from 'react-router-dom';
import priceFormat from '../../utils/showPriceFormat';
// import formatNumber from '../admin/Dress/util/showPrice';
import './SuccessOrder.css';


const SuccessfullOrder = () => {
    const { state } = useLocation();
    const { factureNumber, price, fullName, mobileNumber, address, DateAndTime } = state;

    return ( 
        <div className="successPage">
            <header className="header-successPage">
                <div className="background-layer-successPage"></div>
            </header>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-9 col-lg-7 col-xl-6 ">
                        <div className="success-icon text-center mt-2">
                            <i className="fa fa-check-circle text-success"></i>
                        </div>
                        <div className="text-center mt-3 mb-4">
                            <h5 className="text-success">سفارش شما با موفقیت ثبت شد</h5>
                        </div>
                        {/* <div className="line-seperator-item"></div> */}
                        <div className="d-flex flex-wrap background-success-facture">
                            <div className="col-6 font-weight-bold">شماره فاکتور : </div>
                            <div className="col-6 text-right">{factureNumber}</div>
                            <div className="col-6 font-weight-bold">مبلغ پرداختی : </div>
                            <div className="col-6 text-right">{priceFormat(price)}</div>
                            <div className="col-6 font-weight-bold mt-1">نام گیرنده : </div>
                            <div className="col-6 text-right mt-1">{fullName}</div>
                            <div className="col-6 font-weight-bold">تلفن : </div>
                            <div className="col-6 text-right">{mobileNumber}</div>
                            <div className="col-6 font-weight-bold">آدرس : </div>
                            <small className="col-12 col-md-6 text-md-right">{address}</small>
                            <div className="col-5 font-weight-bold">تاریخ ثبت : </div>
                            <small className="col-7 text-right" style={{direction:'ltr'}}>{DateAndTime}</small>
                        </div>
                        {/* <div className="line-seperator-item"></div> */}
                        <div className="text-center my-3">
                            <p className="text-dark">
                                برای تایید نهایی سفارش همکاران ما 
                                به زودی با شما تماس خواهند گرفت . اگه نیاز به دریافت فوری 
                                سفارش خود رادارید ، با شماره های 
                                <span className="font-weight-bold mx-1">05130000000</span>
                                    یا
                                <span className="font-weight-bold mx-1">09153218853</span>
                                 تماس بگیرید
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
     );
}



export default SuccessfullOrder;